'use client'

import {
  setupFirebaseMessaging,
} from '@/lib/firebase/firebase.client'

type EnablePushArgs = {
  userId: number
  sellerId?: number | null
}

function detectPlatform() {
  const ua =
    navigator.userAgent.toLowerCase()

  if (
    /iphone|ipad|ipod/.test(ua)
  ) {
    return 'ios'
  }

  if (/android/.test(ua)) {
    return 'android'
  }

  if (/macintosh|mac os x/.test(ua)) {
    return 'macos'
  }

  if (/windows/.test(ua)) {
    return 'windows'
  }

  return 'web'
}

export async function enablePushNotifications({
  userId,
  sellerId,
}: EnablePushArgs) {
  if (
    typeof window === 'undefined' ||
    !('Notification' in window)
  ) {
    return {
      ok: false,
      error: 'NOT_SUPPORTED',
    }
  }

  console.log(
    '[push] current permission',
    Notification.permission
    )

    const permission =
    Notification.permission === 'granted'
        ? 'granted'
        : await Notification.requestPermission()

    console.log(
    '[push] permission result',
    permission
    )

  if (permission !== 'granted') {
    return {
      ok: false,
      error:
        permission === 'denied'
          ? 'PERMISSION_DENIED'
          : 'PERMISSION_DISMISSED',
    }
  }

  let saved = false

  console.log(
    '[push] starting Firebase registration'
    )

  const result =
    await setupFirebaseMessaging(
      async (
        token
      ) => {
        try {
          const res = await fetch(
            '/api/push/subscribe',
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                'x-user-id':
                  String(userId),
              },
              body: JSON.stringify({
                token,
                sellerId:
                  sellerId || null,
                domain:
                  window.location.host,
                platform:
                  detectPlatform(),
                language:
                  navigator.language ||
                  null,
              }),
            }
          )

          const json =
            await res.json()

          if (
            !res.ok ||
            !json?.ok
          ) {
            console.error(
              '[push] save subscription failed',
              json
            )

            return
          }

          saved = true

          console.log(
            '[push] registered',
            {
              token,
              subscriptionId:
                json.subscriptionId,
            }
          )
        } catch (error) {
          console.error(
            '[push] save subscription error',
            error
          )
        }
      }
    )

  if (!result.supported) {
    return {
      ok: false,
      error: 'NOT_SUPPORTED',
    }
  }

  return {
    ok: true,
    permission,
    saved,
  }
}